import Immutable from "seamless-immutable";
import * as actionTypes from "./actionTypes";

const initialState = Immutable({
  byId: {},
  params: {},
  error: "",
  weeklyDigest: {
    byId: {},
  },
  dailyEmail: {
    byId: {},
  },
  principalEmail: {
    byId: {},
  },
  actionsloading: false,
});

export function sendEmailsReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.SEND_EMAILS:
    case actionTypes.GET_WEEKLY_EMAIL_TEXT:
      return {
        ...state,
        byId: {},
        weeklyDigest: {
          ...state.weeklyDigest,
          byId: {},
        },
        dailyEmail: {},
        principalEmail: {},
        error: "",
        actionsloading: true,
      };
    case actionTypes.SAVE_EMAIL_TEXT:
    case actionTypes.UPDATE_EMAIL_TEXT:
      return {
        ...state,
        actionsloading: true,
      };
    case actionTypes.GET_WEEKLY_EMAIL_TEXT_SUCCESS:
      return {
        ...state,
        weeklyDigest: {
          ...state.weeklyDigest,
          byId: action.payload.byId || {},
        },
        actionsloading: false,
      };
    case actionTypes.SAVE_EMAIL_TEXT_SUCCESS:
    case actionTypes.UPDATE_EMAIL_TEXT_SUCCESS:
      return {
        ...state,
        weeklyDigest: {
          ...state.weeklyDigest,
          byId: {
            ...state.weeklyDigest.byId,
            [action.payload.weeklyemailtextUid]: action.payload,
          },
        },
        actionsloading: false,
      };
    case actionTypes.SEND_EMAILS_SUCCESS:
      return {
        ...state,
        byId: action.payload.byId || {},
        actionsloading: false,
      };
    case actionTypes.SEND_EMAILS_FAILED:
      return {
        ...state,
        error: action.payload,
        actionsloading: false,
      };
    case actionTypes.CLEAR_SEND_EMAIL_STATE:
      return {
        ...state,
        byId: {},
        error: "",
        actionsloading: false,
      };
    default:
      return state;
  }
}
